/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceMyPositionStatItem } from './SurfaceMyPositionStatItem';
import {
    SurfaceMyPositionStatItemFromJSON,
    SurfaceMyPositionStatItemFromJSONTyped,
    SurfaceMyPositionStatItemToJSON,
    SurfaceMyPositionStatItemToJSONTyped,
} from './SurfaceMyPositionStatItem';

/**
 * User rank/score/stats widget configuration
 * @export
 * @interface SurfaceMyPositionConfig
 */
export interface SurfaceMyPositionConfig {
    /**
     * Widget title (e.g. "MY POSITION")
     * @type {string}
     * @memberof SurfaceMyPositionConfig
     */
    title?: string;
    /**
     * Badge/avatar icon URL
     * @type {string}
     * @memberof SurfaceMyPositionConfig
     */
    profileImageUrl?: string;
    /**
     * Top-level stats (e.g. Rank, Score)
     * @type {Array<SurfaceMyPositionStatItem>}
     * @memberof SurfaceMyPositionConfig
     */
    primaryStats?: Array<SurfaceMyPositionStatItem>;
    /**
     * Additional stats row (e.g. Wins, Kills)
     * @type {Array<SurfaceMyPositionStatItem>}
     * @memberof SurfaceMyPositionConfig
     */
    secondaryStats?: Array<SurfaceMyPositionStatItem>;
    /**
     * CTA button label (e.g. "VIEW LEADERBOARD")
     * @type {string}
     * @memberof SurfaceMyPositionConfig
     */
    ctaText?: string;
    /**
     * Block ID to scroll to on CTA click
     * @type {string}
     * @memberof SurfaceMyPositionConfig
     */
    ctaTargetBlockId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceMyPositionConfig
     */
    dataSource?: SurfaceMyPositionConfigDataSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceMyPositionConfig
     */
    competitionId?: string;
    /**
     * Ledger board (LedgerBoard) id — required when dataSource is LEDGER.
     * @type {string}
     * @memberof SurfaceMyPositionConfig
     */
    ledgerBoardId?: string;
}


/**
 * @export
 */
export const SurfaceMyPositionConfigDataSourceEnum = {
    COMPETITION: 'COMPETITION',
    HUB_POINTS: 'HUB_POINTS',
    LEDGER: 'LEDGER'
} as const;
export type SurfaceMyPositionConfigDataSourceEnum = typeof SurfaceMyPositionConfigDataSourceEnum[keyof typeof SurfaceMyPositionConfigDataSourceEnum];


/**
 * Check if a given object implements the SurfaceMyPositionConfig interface.
 */
export function instanceOfSurfaceMyPositionConfig(value: object): value is SurfaceMyPositionConfig {
    return true;
}

export function SurfaceMyPositionConfigFromJSON(json: any): SurfaceMyPositionConfig {
    return SurfaceMyPositionConfigFromJSONTyped(json, false);
}

export function SurfaceMyPositionConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceMyPositionConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'profileImageUrl': json['profileImageUrl'] == null ? undefined : json['profileImageUrl'],
        'primaryStats': json['primaryStats'] == null ? undefined : ((json['primaryStats'] as Array<any>).map(SurfaceMyPositionStatItemFromJSON)),
        'secondaryStats': json['secondaryStats'] == null ? undefined : ((json['secondaryStats'] as Array<any>).map(SurfaceMyPositionStatItemFromJSON)),
        'ctaText': json['ctaText'] == null ? undefined : json['ctaText'],
        'ctaTargetBlockId': json['ctaTargetBlockId'] == null ? undefined : json['ctaTargetBlockId'],
        'dataSource': json['dataSource'] == null ? undefined : json['dataSource'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'ledgerBoardId': json['ledgerBoardId'] == null ? undefined : json['ledgerBoardId'],
    };
}

export function SurfaceMyPositionConfigToJSON(json: any): SurfaceMyPositionConfig {
    return SurfaceMyPositionConfigToJSONTyped(json, false);
}

export function SurfaceMyPositionConfigToJSONTyped(value?: SurfaceMyPositionConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'profileImageUrl': value['profileImageUrl'],
        'primaryStats': value['primaryStats'] == null ? undefined : ((value['primaryStats'] as Array<any>).map(SurfaceMyPositionStatItemToJSON)),
        'secondaryStats': value['secondaryStats'] == null ? undefined : ((value['secondaryStats'] as Array<any>).map(SurfaceMyPositionStatItemToJSON)),
        'ctaText': value['ctaText'],
        'ctaTargetBlockId': value['ctaTargetBlockId'],
        'dataSource': value['dataSource'],
        'competitionId': value['competitionId'],
        'ledgerBoardId': value['ledgerBoardId'],
    };
}

